// Запросы к /api/billing/*, биллинг подписок Resstro (отдельный shop ЮKassa).
// Помимо `/api/public` используем второй namespace, чтобы платёжный flow
// не пересекался с гостевым YuKassa-вебхуком и публичными OTP-роутами.
import { ApiError } from './api';
import { getAccessToken } from './auth';

const API_ORIGIN = (import.meta.env.VITE_API_URL?.trim() || '').replace(/\/+$/, '');
const BASE = `${API_ORIGIN}/api/billing`;

export interface CheckoutResponse {
  paymentId: string;
  confirmationUrl: string;
  amountKop: number;
}

async function post<T>(path: string, body: unknown): Promise<T> {
  const token = getAccessToken();
  const res = await fetch(`${BASE}${path}`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const ct = res.headers.get('content-type') ?? '';
    if (ct.includes('application/json')) {
      const data = (await res.json().catch(() => ({}))) as {
        error?: string;
        code?: string;
      };
      throw new ApiError(res.status, data.error || `HTTP ${res.status}`, data.code);
    }
    throw new ApiError(res.status, `HTTP ${res.status}`);
  }
  return (await res.json()) as T;
}

// У каждого заведения владельца своя подписка, оплачиваются они отдельно.
// establishmentId — какую точку оплачиваем; не задан — домашнее заведение.
export const createBillingCheckout = (body: {
  establishmentId?: string;
  planCode?: string;
  billingPeriod?: 'MONTHLY' | 'YEARLY';
  returnUrl?: string;
}) => post<CheckoutResponse>('/checkout', body);

export const cancelBillingSubscription = (reason?: string, establishmentId?: string) =>
  post<{ ok: true }>('/cancel', {
    ...(reason ? { reason } : {}),
    ...(establishmentId ? { establishmentId } : {}),
  });

// Запланировать смену тарифа на следующий период (без оплаты сейчас).
export const scheduleBillingPlanChange = (body: {
  establishmentId?: string;
  planCode: string;
  billingPeriod: 'MONTHLY' | 'YEARLY';
}) =>
  post<{ scheduledAt: string; planCode: string; billingPeriod: 'MONTHLY' | 'YEARLY' }>(
    '/schedule',
    body,
  );

export const cancelScheduledBillingPlanChange = () =>
  post<{ ok: true }>('/schedule/cancel', {});
